<template>
     <div class="alert alert-danger" role="alert">
        Sorry! An error occured.
    </div>
</template>

<style scoped>

</style>